import NewMultipleManipulatedOrders from '../components/manipulated_orders/new_multiple_manipulated_orders'
import NewMultipleManipulatedOrdersForBook from '../components/books/new_multiple_manipulated_orders_for_book.vue'

export default {
  components: {
    NewMultipleManipulatedOrders,
    NewMultipleManipulatedOrdersForBook
  },
  data: () => ({
  }),
}